import {useEffect} from 'react';

// Safari's keyboard can shrink the visual viewport without resizing fixed layouts.
export default function useWorkspaceViewport(active) {
 useEffect(()=>{
  if(!active)return;
  const viewport=window.visualViewport,root=document.documentElement;
  const properties=['--workspace-viewport-height','--workspace-viewport-top','--workspace-keyboard-inset'];
  const update=()=>{
   // Preserve browser pinch zoom instead of resizing the app around it.
   if(viewport?.scale&&viewport.scale!==1)return;
   const height=Math.min(viewport?.height||window.innerHeight,window.innerHeight),top=viewport?.offsetTop||0;
   root.toggleAttribute('data-workspace-short-viewport',height<550);
   root.style.setProperty(properties[0],`${height}px`);
   root.style.setProperty(properties[1],`${top}px`);
   root.style.setProperty(properties[2],`${Math.max(0,window.innerHeight-height-top)}px`);
  };
  update();window.addEventListener('resize',update);
  viewport?.addEventListener('resize',update);viewport?.addEventListener('scroll',update);
  return()=>{window.removeEventListener('resize',update);viewport?.removeEventListener('resize',update);viewport?.removeEventListener('scroll',update);properties.forEach(name=>root.style.removeProperty(name));root.removeAttribute('data-workspace-short-viewport');};
 },[active]);
}
